export default __webpack_public_path__ + "static/media/File-Number.15730f5a.zip";